// Pages
// Go here

// Components
import initStickyBuyButton from "./components/sticky-buy-button";

// Initialize components
document.addEventListener("DOMContentLoaded", () => {
  // example();
  // initStickyBuyButton();

});

window.addEventListener("load", () => {
});

// if (window.shinery.theme.template.indexOf('index') >= 0) {

// }

// if (window.shinery.theme.template.indexOf("product") >= 0) {
// }

// if (window.shinery.theme.template.indexOf('collection') >= 0) {

// }

// if (window.shinery.theme.template.indexOf('page') >= 0) {

// }

// if (window.shinery.theme.template.indexOf('cart') >= 0) {

// }

// if (window.shinery.theme.template.indexOf('article') >= 0) {

// }

document.addEventListener("shopify:section:load", () => {});

console.log("test log");
